import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const report = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getRestrictionReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/restrictions`, config)
  },
  getFilterRestrictionReport () {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/restrictions/filters`)
  },
  getRestrictionReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/restrictions/file`, config)
  },
  getUnbookedEntranceReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/unbooked-entrances`, config)
  },
  getFilterUnbookedEntranceReport () {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/unbooked-entrances/filters`)
  },
  getUnbookedEntranceReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/reports/unbooked-entrances/file`, config)
  }
}

export default report
